import {Component, inject} from "@angular/core";
import {MatButtonModule} from "@angular/material/button";
import {MatExpansionModule} from "@angular/material/expansion";
import {BootstrapIcon} from "src/app/services/header.service";
import {ProductionLineService} from "src/app/features/admin/data-access/production-line.service";
import {CommonModule} from "@angular/common";
import {WorkstationService} from "src/app/features/admin/data-access/workstation.service";
import {SelectionService} from "src/app/services/selection.service";
import {RouterModule} from "@angular/router";
import {NavigationService} from "src/app/shared/data-access/navigation.service";
import {ProductionLine} from "src/app/shared/interfaces/productionLine";
import {ApiService} from "src/app/services/api.service";
import {EditDeleteButtonsComponent} from "../../../components/edit-delete-buttons/edit-delete-buttons.component";

@Component({
  selector: "app-production-line-view",
  templateUrl: "./production-line-view.component.html",
  styleUrls: ["./production-line-view.component.scss"],
  standalone: true,
  imports: [
    MatButtonModule,
    MatExpansionModule,
    CommonModule,
    RouterModule,
    EditDeleteButtonsComponent,
  ],
})
export class ProductionLineViewComponent {
  public BootstrapIcon = BootstrapIcon;
  productionLineService = inject(ProductionLineService);
  workstationService = inject(WorkstationService);
  selectionService = inject(SelectionService);
  navigationServive = inject(NavigationService);
  apiService = inject(ApiService);

  productionLines = this.productionLineService.productionLines();

  setSelection(id: string) {
    this.selectionService.changeProductionLine(id);
  }

  setProductionLineBeingEdited(productionLine: ProductionLine) {
    this.productionLineService.productionLineBeingEdited$.next(productionLine);
  }

  deleteWorkstation(id: string, deletedPosition: number) {
    if (confirm("Soll der Arbeitsplatz wirklich gelöscht werden?") === true) {
      this.workstationService.delete$.next(id);
      this.updatePositions(deletedPosition);
    }
  }

  async updatePositions(deletedPosition: number) {
    for (let workstation of this.workstationService.filteredWorkstations()) {
      if (workstation.position > deletedPosition) {
        workstation.position--;
      }
      await this.apiService.updateWorkstationPosition(
        workstation.id!,
        workstation.position
      );
    }
  }
}
